// extracted by mini-css-extract-plugin
export default {"BodyParagraph":"_BodyParagraph--f8Nkk","BodyParagraphRed":"_BodyParagraphRed--Zth0f","BulletList":"_BulletList--NEfu8","ListItem":"_ListItem--enhyc"};